import classNames from 'classnames';
import React, { forwardRef } from 'react';

export type OwnProps = React.SVGProps<SVGSVGElement> & {
  blue?: boolean;
  lightBlue?: boolean;
  darkBlue?: boolean;
  darkGray?: boolean;
  isFavorited?: boolean;
  whiteFill?: boolean;
};

const HeartWithBorder = forwardRef<SVGSVGElement, OwnProps>(
  (
    { blue, lightBlue, darkBlue, darkGray, isFavorited, whiteFill, ...props },
    ref
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      ref={ref}
      {...props}
      data-favorited={isFavorited}
      data-testid="heart-icon"
    >
      <path
        className={classNames('u:fill-none', {
          'stroke-slate-600': darkGray && !isFavorited,
          'stroke-blue-2': lightBlue && !isFavorited,
          'stroke-blue-4': blue && !isFavorited,
          'stroke-blue-6': darkBlue && !isFavorited,
          'fill-white': whiteFill && !isFavorited,
          'fill-red-2 stroke-red-2': isFavorited
        })}
        d="M2.42871 2.44197L2.42886 2.44182C3.35213 1.50865 4.57103 1 5.87406 1C7.16314 1 8.37481 1.50063 9.29245 2.41689L9.998 3.12138L10.7046 2.41792C12.6085 0.522407 15.6799 0.529965 17.5703 2.44067L17.5705 2.44084C19.4731 4.36311 19.4764 7.49343 17.581 9.41875L9.99287 16.6208L2.41869 9.42154C0.523469 7.49358 0.527411 4.36284 2.42871 2.44197Z"
        stroke="#00aed9"
        strokeWidth="2"
      />
    </svg>
  )
);

export default HeartWithBorder;
